import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaModulosResponse } from '../../responses/usuario/lista-modulos.response';

@Injectable({
  providedIn: 'root',
})
export class ModuloService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(): Observable<ListaModulosResponse> {
    let uri: string = `Modulo/admin`;

    return this.httpClient
      .get<ListaModulosResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
